<div class="container">
    <div class="text-center">
        <app-search-bar></app-search-bar>
    </div>
    <ng-template [ngIf]="searchService.isOptionsEmpty$  | async" [ngIfElse]="show">
        <div class="jumbotron jumbotron-fluid">
            <div class="container">
                <h1 class="display-4">CEPLAN</h1>
                <p class="lead">No se encontraron coincidencias para la búsqueda realizada.
                </p>
            </div>
        </div>
    </ng-template>

    <ng-template #show>
        <div *ngIf="searchService.options$ | async as selectedOptions">
            <div class="row">
                <span class="result__found" *ngIf="selectedOptions.length > 1">
                    Se encontraron <b>{{selectedOptions.length}} publicaciones</b><span *ngIf="highlights"> para <b>{{highlights}}</b></span> 
                </span>
                <span class="result__found" *ngIf="selectedOptions.length === 1">
                    Se encontró <b>{{selectedOptions.length}} publicación</b><span *ngIf="highlights"> para <b>{{highlights}}</b></span> 
                </span>
            </div>
            <ng-container
                *ngFor="let item of selectedOptions| paginate:{itemsPerPage:10, currentPage:pages}; let i = index">
                <div class="row" *ngIf="selectedOptions.length > 0">
                    <article class="excerpt">
                        <header class="excerpt__header">
                            <div class="excerpt__title">
                                <a [routerLink]="['../ficha/'+ item.code]" target="_blank">
                                    {{item.longtitle}}
                                </a>
                            </div>
                            <div class="post__meta">
                                <em *ngIf="item.lastUpdated">{{ item.lastUpdated|date}}</em><em
                                    *ngIf="!item.lastUpdated">{{ item.publication|date}}</em><em>{{item.title}}</em>
                                <ng-container *ngIf="dptoList.length > 0">
                                    <em *ngIf="getDptoName(item.iddpto)">{{
                                        getDptoName(item.iddpto) }}</em>
                                </ng-container>
                                <ng-container *ngIf="sectorList.length > 0">
                                    <em *ngIf="getSectorName(item.idsector)">Sector: {{
                                        getSectorName(item.idsector)}}</em>
                                </ng-container>
                            </div>
                        </header>
                        <div class="excerpt__body">
                            <p [innerHTML]="item.summary| highlights:highlights"></p>
                        </div>
                        <hr class="final__line">
                    </article>
                </div>
            </ng-container>
            <!-- <ng-container *ngIf="selectedOptions.length > 10"> -->
            <div class="text-center">
                <pagination-controls (pageChange)="pages = $event" previousLabel="Anterior" nextLabel="Siguiente">
                </pagination-controls>
            </div>
            <!-- </ng-container> -->
        </div>
    </ng-template>
</div>